import { render, staticRenderFns } from "./Filter-item.vue?vue&type=template&id=046fd1d0&"
import script from "./Filter-item.vue?vue&type=script&lang=js&"
export * from "./Filter-item.vue?vue&type=script&lang=js&"
import style0 from "./Filter-item.vue?vue&type=style&index=0&id=046fd1d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports